/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
/**
 * Sets benefit selection as chosen by the user.
 */

var BENEFIT_SELECTION_VALIDATION_ERRORS = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, 'BenefitSelection', 'BENEFIT_SELECTION_VALIDATION_ERRORS'); // eslint-disable-next-line import/prefer-default-export

export { BENEFIT_SELECTION_VALIDATION_ERRORS };